import Tooltip from '2-core-elements/Tooltip/Tooltip';

const changeDatepickerFormat = (): void => {
    if (typeof window.$$epiforms !== 'undefined') {
        const { $$epiforms } = window;
        $$epiforms(document).ready(() => {
            $$epiforms('.EPiServerForms, [data-f-type="form"]').on('formsNavigationNextStep formsSetupCompleted', () => {
                const datepickerEl = document.querySelectorAll('.FormDateTime input.hasDatepicker');
                if (!datepickerEl.length) {
                    return;
                }

                datepickerEl.forEach(input => {
                    const dateFormat = input.getAttribute('data-dateFormat') || 'dd/mm/yy';
                    $$epiforms(input).datetimepicker('option', { dateFormat });
                });
            });
        });
    }
};

const initTooltip = (elCaption: HTMLDivElement, tooltipText: string): void => {
    const tooltipEl = document.createElement('span');
    tooltipEl.classList.add('Form__Element__Tooltip');
    elCaption.appendChild(tooltipEl);

    Tooltip({
        el: tooltipEl,
        props: { content: tooltipText },
    });
};

const adjustFormElementLabel = (elCaption: HTMLDivElement): void => {
    const label = elCaption.textContent;
    const newLabel = document.createElement('span');
    newLabel.classList.add('Form__Element__Caption-Text');
    newLabel.textContent = label;
    elCaption.textContent = '';
    elCaption.appendChild(newLabel);
};

const getTooltipText = (element: HTMLElement): string | null => {
    const isInput = element.classList.contains('FormTextbox') || element.classList.contains('FormDateTime');
    const isChoices = element.classList.contains('FormChoice');

    if (isInput) {
        const inputEl = element.querySelector<HTMLInputElement>('.FormTextbox__Input, .FormDateTime__Input');
        return inputEl?.hasAttribute('title') && inputEl?.getAttribute('title') !== '' ? inputEl.getAttribute('title') : null;
    }

    if (isChoices) {
        return element.hasAttribute('title') && element.getAttribute('title') !== '' ? element.getAttribute('title') : null;
    }

    return null;
};

const processFormElement = (element: HTMLDivElement): void => {
    const elCaption = element.querySelector<HTMLDivElement>('.Form__Element__Caption');
    const hasCaption = elCaption?.textContent && elCaption.textContent.trim() !== '';
    const isSubmitButton = element.classList.contains('FormSubmitButton');

    if (hasCaption) {
        adjustFormElementLabel(elCaption);
    }

    const tooltipText = getTooltipText(element);
    if (tooltipText && hasCaption) {
        initTooltip(elCaption, tooltipText);
    }

    if (isSubmitButton) {
        const wrapper = document.createElement('div');
        wrapper.classList.add('Form__Element', 'Form__Element__SubmitWrapper');
        element.parentNode?.insertBefore(wrapper, element);
        wrapper.appendChild(element);
    }
};

const FormSection = (): void => {
    const FormElements = document.querySelectorAll<HTMLDivElement>('.Form__Element');

    if (FormElements) {
        FormElements.forEach(element => {
            processFormElement(element);
        });
    }

    changeDatepickerFormat();
};

export default FormSection;
